import { render, staticRenderFns } from "./TabTrusters.vue?vue&type=template&id=8b90415c&"
import script from "./TabTrusters.vue?vue&type=script&lang=js&"
export * from "./TabTrusters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports